// eslint-disable-next-line
import { BasicLayout } from "@/components/Layouts/index";
import { check_browser } from "@/utils";

export default [
  {
    path: "/main",
    name: "Main",
    component: BasicLayout,
    redirect: check_browser() !== "pc" ? "/mobile" : "/main/home",
    children: [
      {
        path: "/main/home",
        name: "Home",
        meta: { title: "首页" },
        component: () => import("@/views/Home.vue"),
      },
      {
        path: "/main/info",
        name: "Info",
        meta: { title: "信息查询" },
        component: () => import("@/views/Info.vue"),
      },
      {
        path: "/main/help",
        name: "Help",
        meta: { title: "帮助" },
        redirect: "/main/help/question/help1",
        component: () => import("@/views/Help/Index.vue"),
        children: [
          {
            path: "/main/help/question/:anchor?",
            name: "HelpQuestion",
            meta: { title: "帮助" },
            component: () => import("@/views/Help/HelpContent.vue"),
          },
          {
            path: "/main/help/agreement",
            name: "HelpPrivacy",
            meta: { title: "隐私政策" },
            component: () => import("@/views/Help/PrivacyPolicy.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "/mobile",
    name: "Mobile",
    meta: { title: "移动端首页", customTit: "标日电子书" },
    component: () => import("@/views/Mobile.vue"),
  },
  {
    path: "/login",
    name: "Login",
    meta: { title: "登录" },
    component: () => import("@/views/Login.vue"),
  },
  {
    path: "/gaokao",
    name: "Gaokao",
    meta: { title: "学习" },
    redirect: "/gaokao/list",
    component: () => import("@/views/Gaokao/Index.vue"),
    children: [
      {
        path: "/gaokao/list",
        name: "GaokaoList",
        meta: { title: "图书激活" },
        component: () => import("@/views/Gaokao/List.vue"),
      },
      {
        path: "/gaokao/search",
        name: "GaokaoSearch",
        meta: { title: "账号查询" },
        component: () => import("@/views/Gaokao/Search.vue"),
      },
      {
        path: "/gaokao/courseware",
        name: "GaokaoCourseware",
        meta: { title: "课件学习" },
        component: () => import("@/views/Gaokao/Study.vue"),
      },
    ],
  },

  {
    path: "/code/:param",
    name: "CodePage",
    meta: { title: "商品信息", customTit: "日语教材" },
    component: () => import("@/views/Code/Index.vue"),
  },

  {
    path: "*",
    name: "default",
    redirect: "/main",
  }, // 添加通配符路由
];
